import ITransportCategory from 'interfaces/ITransportCategory';
import RestService from './RestService';

export default class TransportCategoryService extends RestService<ITransportCategory> {
  constructor() {
    super('transport-categories');
  }
}
